export default "__VITE_ASSET__BPC2IamB__"